import React, { useEffect } from 'react';
import { User } from 'web/model/User';
import styles from './index.module.scss';
import classNames from 'classnames';

interface SupportFormPopupProps {
  onClose: () => void;
  user: User;
}

const SupportFormPopup = ({ onClose, user }: SupportFormPopupProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.onload = () => {
      const company = user.organizations.length > 0 ? user.organizations[0].name : '';
      const email = user.email;
      const firstName = user.firstName;
      const lastName = user.lastName;
      const currentPageUrl = window.location.href;

      // @ts-ignore
      window.hbspt.forms.create({
        region: 'na1',
        portalId: '44914279',
        formId: '2adaf3d9-65a2-4263-be43-632097857200',
        target: '#hubspotForm',
        onFormReady: (form: any) => {
          const setValue = (name: string, value: string) => {
            const input = form.querySelector(`input[name="${name}"]`) as HTMLInputElement;
            if (input) {
              input.value = value;
              input.dispatchEvent(new Event('input', { bubbles: true })); // Trigger input event
            }
          };

          setValue('company', company);
          setValue('email', email);
          setValue('firstname', firstName);
          setValue('lastname', lastName);
          setValue('city', currentPageUrl);
        }
      });
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [user]);

  return (
    <div className={classNames(styles.fixed, styles.inset0, styles.flex, styles.itemsCenter, styles.justifyCenter, styles.bgBlack, styles.bgOpacity50, styles.z50)}>
      <div className={classNames(styles.bgWhite, styles.p4, styles.roundedLg, styles.shadowLg, styles.w11_12, styles.mdW1_2)}>
        <button onClick={onClose} className={styles.floatRight}>
          Close
        </button>
        <div id="hubspotForm"></div>
      </div>
    </div>
  );
};

export default SupportFormPopup;
